module.exports = __webpack_public_path__ + "img/man-body-back.a4f83ec3.png";